import { render, staticRenderFns } from "./TextConfigurationView.vue?vue&type=template&id=14971312"
import script from "./TextConfigurationView.vue?vue&type=script&lang=js"
export * from "./TextConfigurationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports